import { Component } from '@angular/core';
import { AbstractDialogComponent } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-period-ended-dialog',
  templateUrl: './period-ended-dialog.component.html',
  styleUrls: ['./period-ended-dialog.component.scss'],
})
export class PeriodEndedDialogComponent extends AbstractDialogComponent {
  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  onClose(): void {
    this.activeModal.close();
  }
}
